<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>学员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="search-wrapper">
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="" v-model="stuPhone">
            <template slot="prepend">学员手机号</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-select v-model="status" clearable placeholder="课程状态" style="width: 100%;">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="schoolId" clearable placeholder="学校库存" style="width: 100%;">
            <el-option
              v-for="item in schoolOptions"
              :key="item.uuid"
              :label="item.schoolName"
              :value="item.uuid">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="教练NO" v-model="insNo">
            <template slot="prepend">教练库存</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-button
            style="width: 100%;"
            type="primary"
            @click="search"
          >查询
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-table
      class="table"
      :data="studentList"
      :max-height="tableHeight"
      style="width: 100%">
      <el-table-column
        fixed="left"
        prop="ownerName"
        label="库存所有者"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="courseName"
        label="课程名称"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="insName"
        label="教练"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="courseStatusDesc"
        label="课程状态"
        align="center"
        width="130">
      </el-table-column>
      <el-table-column
        prop="stuName"
        label="学员姓名"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="phoneNo"
        label="手机号"
        align="center"
        width="130">
      </el-table-column>
      <el-table-column
        prop="entryTime"
        label="最后更新时间"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="goToDetail(scope.row)"
          >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '@/common/js/config';
  import { getSchools } from '@/api/order';
  import { getStudentList } from '@/api/student';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'student_list',
    data() {
      return {
        statusOptions: [{
          value: 0,
          label: '课程绑定'
        }, {
          value: 1,
          label: '账户激活'
        }, {
          value: 2,
          label: '完善信息'
        }, {
          value: 3,
          label: '线上考核通过'
        }, {
          value: 4,
          label: '技术考核通过'
        }, {
          value: 5,
          label: '学员卡发放'
        }],
        status: null,
        stuPhone: '',
        schoolOptions: [],
        schoolId: '',
        insNo: '',
        currentPage: 1,
        total: 0,
        tableHeight: 500,
        pageSize: 3
      };
    },
    created() {
      this._getSchools();
      if (!this.$route.params.pageNum) {
        this.$router.push('/student_list/1');
        this.currentPage = 1;
        this._getStudentList(1);
      } else {
        this._getStudentList(this.$route.params.pageNum);
        this.currentPage = parseInt(this.$route.params.pageNum);
      }
    },
    mounted() {
      let orderHeight = document.body.clientHeight;
      this.tableHeight = orderHeight - 284;
    },
    methods: {
      search() {
        this.$router.push('/student_list/1');
        this.currentPage = 1;
        this._getStudentList(1);
      },
      goToDetail(student) {
        this.$router.push(`/student_detail/${student.courseStockDetailId}`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.$router.push(`/student_list/${val}`);
        this._getStudentList(val);
      },
      _getSchools() {
        getSchools(this.user.userId).then((res) => {
          this.schoolOptions = res.schools;
        });
      },
      _getStudentList(pageNum) {
        getStudentList(
          this.user.userId,
          pageNum,
          this.status,
          this.stuPhone,
          this.schoolId,
          this.insNo,
        ).then((res) => {
          this.total = res.count;
          this.pageSize = res.pageSize;
          this.setList({
            list: res.courseStuList,
            type: listType.STUDENT
          });
        });
      },
      ...mapActions([
        'setList'
      ])
    },
    computed: {
      ...mapGetters([
        'studentList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    overflow: scroll;
    .title
      margin-bottom: 20px;
    .search-wrapper
      margin: 0 0 10px 0 !important;
    .add-btn
      margin-bottom: 10px;
    .pagination
      margin-top: 10px;
</style>